var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBold3DSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2.328C4.17 2.328 2 4.508 2 8.148v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81v-8.37c.01-3.64-2.16-5.82-5.8-5.82H7.81zm3.35 15.52c-.14.09-.29.13-.45.13-.13 0-.26-.03-.39-.09l-3.5-1.75c-.5-.26-.82-.77-.82-1.34v-3.31a.867.867 0 0 1 1.25-.77l3.5 1.75c.51.26.83.77.83 1.34v3.31h-.01c0 .3-.15.57-.41.73zM7.6 9.738a.87.87 0 0 1-.44-.77c0-.32.17-.62.44-.77l3.76-2.03c.4-.21.87-.21 1.27 0l3.76 2.03c.27.15.44.44.44.77s-.17.62-.44.77l-3.76 2.03c-.2.11-.42.16-.64.16-.22 0-.43-.05-.63-.16L7.6 9.738zm9.57 6.4-3.5 1.75a.86.86 0 0 1-.39.09c-.16 0-.31-.04-.45-.13a.847.847 0 0 1-.41-.73v-3.31c0-.57.32-1.09.83-1.34l3.5-1.75a.867.867 0 0 1 1.25.77v3.31c0 .57-.32 1.09-.83 1.34z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBold3DSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-3-d-square.f5665e5d85e9cf7b1df8b15bfec8aaf5.svg";
export { ForwardRef as ReactComponent };